import { IpnForm } from 'app/components/Profile/Ids/IpnDialog/types';
import { getDirtyValues } from 'app/utils/utils';
import { toUpdateIpnData } from 'app/components/Profile/Ids/IpnDialog/utils';
import { UseFormHandleSubmit } from 'react-hook-form';
import { FormState } from 'react-hook-form/dist/types/form';
import { Link } from 'types/api.types';
import { SocietyOption } from 'app/components/Profile/Ids/types';
import { Ipn, UpdateIpnData } from 'types/ipn.types';
import { useAppDispatch } from 'app/store';
import { updateProfileEffect } from 'app/store/Profile/effects';

interface UseIpnDialogSubmitProps {
  handleSubmit: UseFormHandleSubmit<IpnForm>;
  dirtyFields: FormState<IpnForm>['dirtyFields'];
  ipn?: Ipn;
  updateIpn: (formData: Partial<UpdateIpnData>, link?: Link) => Promise<Ipn>;
  handleClose: (status?: number) => void;
  addIpnManually: (data: Partial<IpnForm>) => Promise<{ status: number }>;
  handleAddIpnV2: (data: IpnForm) => Promise<void>;
  handleAddIpnV3: (data: SocietyOption) => void;
}

export const useIpnDialogSubmit = ({
  handleSubmit,
  dirtyFields,
  ipn,
  updateIpn,
  handleClose,
  handleAddIpnV2,
  handleAddIpnV3,
  addIpnManually,
}: UseIpnDialogSubmitProps) => {
  const dispatch = useAppDispatch();
  const onSubmit = handleSubmit(async (values: IpnForm) => {
    if (!values.society) return;
    try {
      const { isDefault, ...dirtyValues } = getDirtyValues<IpnForm>(
        dirtyFields,
        values
      );
      if (ipn) {
        await updateIpn(toUpdateIpnData(dirtyValues), ipn._links.updateIpn);
        if (isDefault !== undefined) {
          const value = isDefault ? ipn.ipnNumber : null;
          await dispatch(
            updateProfileEffect({
              formData: {
                preferredIpn: { title: '', value: value as number },
              },
              options: { hideAlerts: true },
            })
          ).unwrap();
        }
        handleClose();
        return;
      }

      const {
        ipnNumber,
        society: { verification },
      } = values;

      switch (verification?.version) {
        case 2:
          await handleAddIpnV2(values);
          break;
        case 3:
          handleAddIpnV3(values.society);
          break;
        default: {
          const result = await addIpnManually(dirtyValues);
          handleClose(result?.status);
          break;
        }
      }
      if (isDefault !== undefined) {
        const value = isDefault ? ipnNumber : null;
        await dispatch(
          updateProfileEffect({
            formData: {
              preferredIpn: { title: '', value: value as string },
            },
            options: { hideAlerts: true },
          })
        ).unwrap();
      }
    } catch (e) {
      // Proceed regardless
    }
  });

  return {
    onSubmit,
  };
};
